import React from 'react';
import PracticeAnalyticsDashboard from './PracticeAnalyticsDashboard';

/** Practice admin home is the analytics dashboard. */
const PracticeAdminHome = () => <PracticeAnalyticsDashboard />;

export default PracticeAdminHome;
